import {VetologyBase} from "../Vetology/VetologyBase";

export class EditClinic extends VetologyBase
{
    constructor()
    {
        super('EditClinic');
    }

    init()
    {
        const _self = this;
	    _self.initEventHandlers();

	    const customLogoMarkup = document.querySelector(".custom-logo-markup");
	    const customLogoEnabledSwitch = document.querySelector("input[name='enableCustomLogo'][checked]");
	    const customLogoEnabled = customLogoEnabledSwitch.value === '1';


	    if (customLogoEnabled) {
		    _self.placeMarkupBeforeImage(customLogoMarkup);
		    customLogoMarkup.classList.remove('hidden');
	    }
    }

    initEventHandlers()
    {
        const _self = this;

        _self.onHtmlTextareaBlur = _self.onHtmlTextareaBlur.bind(_self);
        _self.onRadioSameAsPhysicalAddressClicked = _self.onRadioSameAsPhysicalAddressClicked.bind(_self);

        const form = document.querySelector('form.edit-clinic');
        if (form) {
            const customLogoSwitch = form.querySelectorAll('input[name="enableCustomLogo"]');
            customLogoSwitch.forEach((inputElem) => {
                inputElem.closest('label').addEventListener('click', (event) => { _self.onEnableCustomLogoClick(event) });
            });
            this.addEventListenByEnablePartnerList(form, ['enableVetrocket', 'enableDaySmart', 'enableEzyVet', 'enableHappyDoc']);

            const htmlTextArea = document.querySelector('textarea.custom-html');
            htmlTextArea.addEventListener('blur', _self.onHtmlTextareaBlur);

            const billingSameAsPhysicalAddressGroup = form.querySelector('div.btn-group.same-as-physical-address');
            if (billingSameAsPhysicalAddressGroup) {
                billingSameAsPhysicalAddressGroup.addEventListener('click', _self.onRadioSameAsPhysicalAddressClicked);
            }
        }
    }

	removeEventHandlers()
	{
		const _self = this;
		const form = document.querySelector('form.edit-clinic');
		if (form) {
			const customLogoSwitch = form.querySelectorAll('input[name="enableCustomLogo"]');
			customLogoSwitch.forEach((inputElem) => {
				inputElem.closest('label').removeEventListener('click', (event) => { _self.onEnableCustomLogoClick(event) });
			});
			this.removeEventListenByEnablePartnerList(form, ['enableVetrocket', 'enableDaySmart', 'enableEzyVet', 'enableHappyDoc']);

			const htmlTextArea = document.querySelector('textarea.custom-html');
			htmlTextArea.removeEventListener('blur', _self.onHtmlTextareaBlur);

		}
	}

    onEnableCustomLogoClick(event)
    {
        const inputElem = event.target.children.namedItem('enableCustomLogo');
        const customLogoEnabled = inputElem.value === '1';
        const logoDataDiv = document.querySelector('div.custom-logo-data');

        if (customLogoEnabled) {
            logoDataDiv.classList.add('down');
        } else {
            logoDataDiv.classList.remove('down');
        }
    }

    onEnablePartnerClinicClick(event, enableName)
    {
        const enablePartner = event.target.children.namedItem(enableName);
        const dataDiv = document.querySelector('div.' + enableName);

        if (enablePartner.value !== '1') {
            dataDiv.classList.add('hidden');
        } else {
            dataDiv.classList.remove('hidden');
        }
    }

    addEventListenByEnablePartnerList(form, enablePartnerList)
    {
        const _self = this;
        enablePartnerList.map((enablePartner)=>{
            const enablePartnerSwitch = form.querySelectorAll('input[name="' + enablePartner + '"]');
            enablePartnerSwitch.forEach((inputElem) => {
                inputElem.closest('label').addEventListener('click', (event) => { _self.onEnablePartnerClinicClick(event, enablePartner) });
            });

        });
    }

    removeEventListenByEnablePartnerList(form, enablePartnerList)
    {
        const _self = this;
        enablePartnerList.map((enablePartner)=>{
            const enablePartnerSwitch = form.querySelectorAll('input[name="' + enablePartner + '"]');
            enablePartnerSwitch.forEach((inputElem) => {
                inputElem.closest('label').removeEventListener('click', (event) => { _self.onEnablePartnerClinicClick(event, enablePartner) });
            });

        });
    }


    onHtmlTextareaBlur(event)
    {
        const html = event.target.value;
        const parser = new DOMParser();
        const htmlMarkup = parser.parseFromString(html, 'text/html');
        const errorNode = htmlMarkup.querySelector('parsererror');

        if (errorNode) {
            toastr.error('The custom html is invalid');
        } else {
            const markupContainer = document.querySelector("div.custom-logo-markup .logo-inner");
            // markupContainer.replaceChildren(htmlMarkup.childNodes);
            markupContainer.innerHTML = html;
            toastr.success('Custom HTML successfully updated');
        }
    }

    onRadioSameAsPhysicalAddressClicked(event)
    {
        const label = event.target;
        const clickedInput = label.querySelector('input');
        const billingContainer = label.closest('div.box-body');
        const fields = billingContainer.querySelectorAll('input');
        if (clickedInput.value == 1) {
            // yes, disable elements
            fields.forEach(elem => {
                elem.setAttribute('disabled', 'disabled');
            });
        } else {
            // no, enable elements
            fields.forEach(elem => {
                elem.removeAttribute('disabled');
            });
        }
    }

    placeMarkupBeforeImage(markupElement)
    {
        const logoElem = document.querySelector("img.img_GooglePlaceIDLogo");
        logoElem.parentElement.insertBefore(markupElement, logoElem);
    }
}
